import { cn } from "@newxsystems/shared";
import { DaylightAction } from "../DaylightAction/DaylightAction";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-5", centered && "items-center text-center")}>
      {eyebrow ? <p className="daylight-label text-primary">{eyebrow}</p> : null}
      {image ? (
        <DaylightMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-4 w-full", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      <div className={cn("flex max-w-[48rem] flex-col gap-5", centered && "items-center")}>
        {heading ? (
          <h2 className="text-balance font-daylight-display text-[clamp(2.25rem,5vw,2.875rem)] font-semibold leading-[1.05] tracking-[-0.035em] text-graphite">
            {heading.split("\n").map((line, index) => (
              <span key={index}>
                {index > 0 ? <br /> : null}
                {line}
              </span>
            ))}
          </h2>
        ) : null}
        {description ? (
          <DaylightRichText className="max-w-[65ch] text-northsea" content={description} />
        ) : null}
        {buttons?.length ? (
          <div className={cn("flex flex-wrap gap-3", centered && "justify-center")}>
            {buttons.map((button, index) => (
              <DaylightAction action={button} key={`${button.href}-${index}`} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
